import React from "react";
import { ActionContainer, Logo, MainContainer } from "./styles";
import LogoWhite from "../../../../assets/svg/logo-white.svg";
import { FaBell, FaCog } from "react-icons/fa";
import ThemeColors from "../../../../themes/colors";
import UserPopover from "../../../../components/UserPopover";

const TopBar: React.FC = (): JSX.Element => {
  return (
    <MainContainer>
      <Logo src={LogoWhite} />
      <ActionContainer>
        <FaBell color={ThemeColors.Bg300} style={{ cursor: "pointer" }} />
        <FaCog color={ThemeColors.Bg300} style={{ cursor: "pointer" }} />
        <UserPopover />
      </ActionContainer>
    </MainContainer>
  );
};

export default TopBar;
